import { PageId } from 'constants/pages'

export const enum PageIdWoofzSubCnld70 {
  SUBSCRIPTIONS_CNLD_70 = PageId.SUBSCRIPTIONS_CNLD_70,
  CHAT_UPSELL_CNLD_70 = PageId.CHAT_UPSELL_CNLD_70,
  UPSELL_CNLD_70 = PageId.UPSELL_CNLD_70,
  DOWNLOAD_CNLD_70 = PageId.DOWNLOAD_CNLD_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
